// require syntax highlighting 
require("prismjs/themes/prism-tomorrow.css")
// export const onServiceWorkerUpdateReady = () => window.location.reload(true)
